export const CLIENT_FLOW_DEFAULT_ROUTE = "/client/account";

export const CLIENT_FLOW_STORAGE_KEYS = {
  COMPANY_PROFILE: "telivi.client.companyProfile",
  TEAM_MEMBERS: "telivi.client.teamMembers",
  INTEGRATIONS: "telivi.client.integrations",
};

export const sanitizeClientReturnTo = (value, fallback = CLIENT_FLOW_DEFAULT_ROUTE) => {
  if (typeof value !== "string") return fallback;
  const trimmed = value.trim();
  if (!trimmed) return fallback;

  if (trimmed.startsWith("/") && !trimmed.startsWith("//")) {
    return trimmed;
  }

  if (typeof window !== "undefined") {
    try {
      const parsed = new URL(trimmed, window.location.origin);
      if (parsed.origin === window.location.origin) {
        return `${parsed.pathname}${parsed.search}${parsed.hash}`;
      }
    } catch (error) {
      return fallback;
    }
  }

  return fallback;
};

export const safeParseJson = (value, fallback) => {
  if (!value) return fallback;
  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
};
